import { render, staticRenderFns } from "./tdkConfig.vue?vue&type=template&id=7512f3f0&scoped=true&"
import script from "./tdkConfig.vue?vue&type=script&lang=js&"
export * from "./tdkConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7512f3f0",
  null
  
)

export default component.exports